<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header green-gradient">Agendas creadas</div>
                    <div class="card-body">
                        <table class="table table-stripped text-center" id="schedules-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Fecha</th>
                                    <th>Hora</th>
                                    <th>Agendado a</th>
                                    <th>Estado</th>
                                    <th>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(currentSchedule, i) in schedules" :key="currentSchedule.id">
                                    <td>{{currentSchedule.id}}</td>
                                    <td>{{currentSchedule.date_format}}</td>
                                    <td>{{currentSchedule.time_format}}</td>
                                    <td><span v-if="currentSchedule.user">{{ currentSchedule.user.first_name }} {{ currentSchedule.user.last_name }}</span></td>
                                    <td>{{ (currentSchedule.attendance == 1)? 'Asistió' : ((currentSchedule.attendance == 2)? 'No asistió' : '') }}</td>
                                    <td width="50px">
                                        <router-link v-if="currentSchedule.user" class="btn btn-success btn-sm mr-1" :to="{name: 'schedule-edit', params:{id: currentSchedule.id}}"  @click="$emit('goToCase')">
                                            <i class="fa fa-eye"></i>
                                        </router-link>
                                        <input type="button" value="✕" class="btn btn-danger btn-sm" @click="deleteSchedule(currentSchedule, i)">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'cities',
    mounted: function(){
        // this.fetchCities();
        this.fetchSchedules();
    },
    data(){
        return {
            baseUrl: process.env.VUE_APP_API,
            cities: [],
            schedules: [],
            schedule: {
                date: "",
                time: '',
            },
            table: null
        }
    },
    methods: {
        fetchCities: function(){
            let _this = this;
            this.$http
            .get(`${this.baseUrl}/public/cities`)
            .then(data => {
                _this.cities = data.body.data;
            })
            .catch(error => {
                console.log(error.error);
            });
        },
        fetchSchedules: function(){
            let _this = this;
            let loader = this.$loading.show();
            this.$http.get(
                `${this.baseUrl}/admin/schedules`, 
                {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(data => {
                _this.schedules = data.body.data;
                var schedulesTable = $("#schedules-table");
                window.setTimeout(()=>{this.renderTable(schedulesTable)}, 0);
                loader.hide();
            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        },
        storeSchedule: function(){
            console.log(this.schedule);
            if(this.schedule.date != "" && this.schedule.time != ''){
                let loader = this.$loading.show();
                this.$http.post(
                    `${this.baseUrl}/admin/schedules`, this.schedule,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
                .then(data => {
                    console.log(data);
                    this.fetchSchedules();
                    loader.hide();
                    this.schedule.date = "";
                    this.schedule.time = "";
                    
                    window.location.reload();
                })
                .catch(error => {
                    loader.hide();
                    this.$dialogs.alert("Ya existe una agenda con esa fecha y hora", {title: 'Error', size: 'sm'});
                });
            } else {
                this.$dialogs.alert("Se requiere una fecha y hora", {title: 'Error', size: 'sm'});
            }
        },
        deleteSchedule(schedule, i){
            let _this = this;
            this.$dialogs.confirm(`¿Desea borrar la agenda con fecha ${schedule.date_format}?`, {title: "Eliminar", size: "sm", okLabel: "Sí", cancelLabel: "Cancelar"})
            .then(response => {
                if(response.ok){
                    const loader = this.$loading.show();
                    const requestUrl = `${this.baseUrl}/admin/schedules/${schedule.id}`;
                    this.$http.delete(requestUrl,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
                    .then(data => {
                        this.$dialogs.alert("Agenda borrada con éxito", {title: "Éxito", size: "sm"});
                        _this.schedules.splice(i, 1);
                        loader.hide();
                    })
                    .catch(error => {
                        if(error.status == 409){
                            loader.hide();
                        }
                    });
                }
            });
        },
        updateZone(zone){
            const loader = this.$loading.show();
            const requestUrl = `${this.baseUrl}/admin/zones/${zone.id}`;
            this.$http.put(requestUrl, zone,
            {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(data => {
                this.$dialogs.alert("Área actualizada con éxito", {title: "Éxito", size: "sm"});
                loader.hide();
            })
            .catch(error => {
                if(error.status == 409){
                    loader.hide();
                    this.$dialogs.alert("No se puede actualizar el área ya que tiene dependencias o casos relacionados", {title: "Error", size: "sm"}).then(()=>{
                        window.location.reload();
                    });
                } else if(error.status == 422){
                    this.$dialogs.alert("Ya existe una área con ese nombre", {title: "Error", size: "sm"}).then(()=>{
                        window.location.reload();
                    });
                }
            })        },
        renderTable(table){
            if(this.table != null){
                this.table.destroy();
            }

            this.table = table.DataTable({
                destroy: true,
                "language": {
                    "sProcessing":     "Procesando...",
                    "sLengthMenu":     "Mostrar _MENU_ registros",
                    "sZeroRecords":    "No se encontraron resultados",
                    "sEmptyTable":     "Ningún dato disponible en esta tabla",
                    "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix":    "",
                    "sSearch":         "Buscar:",
                    "sUrl":            "",
                    "sInfoThousands":  ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst":    "Primero",
                        "sLast":     "Último",
                        "sNext":     "Siguiente",
                        "sPrevious": "Anterior"
                    },
                    "oAria": {
                        "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                    }
                }
            });
        }
    }

}
</script>
<style lang="sass" scoped>
    @import '../../assets/scss/colors';
</style>


